module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-00.1.f3c5c14a.jpg";